<template>
  <div id="chart">
    <div class="mainDiv">
      <el-row>
        <!-- <el-col :span="12" style="">
          <div style="margin: 0 auto;width: 80%;text-align: center;">
            <div style="display: flex;margin-top: 20px;">
              <div
                style="flex: 1;box-shadow: #2d8acf 0px 0px 20px 0px;margin: 5px 5px;padding: 10px;border-radius: 15px;"
              >
                <p class="fkUnit" style="text-align: center;display: block;font-size:20px;">售票总额</p>
                <h1 class="cd-headline slide" style="display: inline-block">
                  <span class="cd-words-wrapper" style="color: #f2c24b;font-size:40px;">
                    <b class="is-visible">{{countSaleMoney}}</b>
                  </span>
                </h1>
                <span>元</span>
              </div>
              <div
                style="flex: 1;box-shadow: #2d8acf 0px 0px 20px 0px;margin: 5px 5px;padding: 10px;border-radius: 15px;"
              >
                <p class="fkUnit" style="text-align: center;display: block;font-size:20px;">售票总人数</p>
                <h1 class="cd-headline slide" style="display: inline-block">
                  <span class="cd-words-wrapper" style="color: #f2c24b;font-size:40px;">
                    <b class="is-visible">{{countSalePerson}}</b>
                  </span>
                </h1>
                <span>人</span>
              </div>
            </div>
          </div>
        </el-col> -->

        <el-col style="" :span="6">
          <div style="margin: 0 auto;width: 80%;text-align: center;">
            <div style="display: flex;margin-top: 20px;">
              <div
                style="flex: 1;box-shadow: #2d8acf 0px 0px 20px 0px;margin: 5px 5px;padding: 10px;border-radius: 15px;"
              >
                <p class="fkUnit" style="text-align: center;display: block;font-size:20px;">销售总金额</p>
                <h1 class="cd-headline slide" style="display: inline-block">
                  <span class="cd-words-wrapper" style="color: #f2c24b;font-size:40px;">
                    <b class="is-visible">{{countSaleMoney}}</b>
                  </span>
                </h1>
                <span>元</span>
              </div>
              
            </div>
          </div>
        </el-col>

        <el-col style="" :span="6">
          <div style="margin: 0 auto;width: 80%;text-align: center;">
            <div style="display: flex;margin-top: 20px;">
              <div
                style="flex: 1;box-shadow: #2d8acf 0px 0px 20px 0px;margin: 5px 5px;padding: 10px;border-radius: 15px;"
              >
                <p class="fkUnit" style="text-align: center;display: block;font-size:20px;">微信总金额</p>
                <h1 class="cd-headline slide" style="display: inline-block">
                  <span class="cd-words-wrapper" style="color: #f2c24b;font-size:40px;">
                    <b class="is-visible">{{countWeixinMoney}}</b>
                  </span>
                </h1>
                <span>元</span>
              </div>
              
            </div>
          </div>
        </el-col>

        <el-col style="" :span="6">
          <div style="margin: 0 auto;width: 80%;text-align: center;">
            <div style="display: flex;margin-top: 20px;">
              <div
                style="flex: 1;box-shadow: #2d8acf 0px 0px 20px 0px;margin: 5px 5px;padding: 10px;border-radius: 15px;"
              >
                <p class="fkUnit" style="text-align: center;display: block;font-size:20px;">美团总金额</p>
                <h1 class="cd-headline slide" style="display: inline-block">
                  <span class="cd-words-wrapper" style="color: #f2c24b;font-size:40px;">
                    <b class="is-visible">{{countMeituanMoney}}</b>
                  </span>
                </h1>
                <span>元</span>
              </div>
              
            </div>
          </div>
        </el-col>

        <el-col style="" :span="6">
          <div style="margin: 0 auto;width: 80%;text-align: center;">
            <div style="display: flex;margin-top: 20px;">
              <div
                style="flex: 1;box-shadow: #2d8acf 0px 0px 20px 0px;margin: 5px 5px;padding: 10px;border-radius: 15px;"
              >
                <p class="fkUnit" style="text-align: center;display: block;font-size:20px;">其他渠道总金额</p>
                <h1 class="cd-headline slide" style="display: inline-block">
                  <span class="cd-words-wrapper" style="color: #f2c24b;font-size:40px;">
                    <b class="is-visible">{{countOtherMoney}}</b>
                  </span>
                </h1>
                <span>元</span>
              </div>
              
            </div>
          </div>
        </el-col>

        <!-- <el-col style="" :span="5">
          <div style="margin: 0 auto;width: 80%;text-align: center;">
            <div style="display: flex;margin-top: 20px;">
              <div
                style="flex: 1;box-shadow: #2d8acf 0px 0px 20px 0px;margin: 5px 5px;padding: 10px;border-radius: 15px;"
              >
                <p class="fkUnit" style="text-align: center;display: block;font-size:20px;">购票总人数</p>
                <h1 class="cd-headline slide" style="display: inline-block">
                  <span class="cd-words-wrapper" style="color: #f2c24b;font-size:40px;">
                    <b class="is-visible">{{countMeituanMoney}}</b>
                  </span>
                </h1>
                <span>元</span>
              </div>
              
            </div>
          </div>
        </el-col> -->
      </el-row>

      <el-row  style="margin-top:20px;">
        <el-col :span="8">
          票种
          <el-select
            size="mini"
            v-model="queryCondition.ticketType"
            clearable
            placeholder="请选择"
            class="dialogDataWidth"
            style="width: 60%;"
          >
            <el-option
              v-for="item in type_option"
              :key="item.code"
              :label="item.value"
              :value="item.code"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :span="8">
          购票来源
          <el-select
            size="mini"
            v-model="queryCondition.ticketFrom"
            clearable
            placeholder="请选择"
            class="dialogDataWidth"
            style="width: 60%;"
          >
            <el-option
              v-for="item in from_option"
              :key="item.code"
              :label="item.value"
              :value="item.code"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :span="8">
          是否验票
          <el-select
            size="mini"
            v-model="queryCondition.ticketStatus"
            clearable
            placeholder="请选择"
            class="dialogDataWidth"
            style="width: 60%;"
          >
            <el-option
              v-for="item in ticket_status"
              :key="item.code"
              :label="item.value"
              :value="item.code"
            ></el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row style="margin-top:10px;">
        <el-col :span="8">
          购票日期
          <el-date-picker
            size="mini"
            v-model="queryCondition.createDate"
            type="daterange"
            :clearable="false"
            style="width: 80%;"
            align="right"
            unlink-panels
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
        </el-col>
        <!-- <el-col :span="8">
          验票日期
          <el-date-picker
            size="mini"
            v-model="queryCondition.checkDate"
            type="daterange"
            clearable
            style="width: 80%;"
            align="right"
            unlink-panels
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
        </el-col> -->
        <el-col :span="8">
          <el-button type="primary" size="mini" @click="query(1)" icon="el-icon-search">查询</el-button>
          <el-button type="primary" plain size="mini" @click="reset" icon="el-icon-refresh">重置</el-button>
          <el-button type="danger" plain size="mini" @click="exportExcel" icon="el-icon-download">导出EXCEL</el-button>
        </el-col>
      </el-row>

      <el-table
        class="el-table"
        stripe
        size="mini"
        :data="pagedata.content"
        align="center"
        style="margin-top: 10px;"
        header-row-class-name="tableHeader"
      >
        <el-table-column
          align="center"
          prop="ticket_sn"
          label="票号"
          label-class-name="greenLabel"
          width="220"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="create_time"
          label="购票时间"
          label-class-name="greenLabel"
        ></el-table-column>
        <el-table-column align="center" prop="status" label="是否消费" :formatter="formatStr" label-class-name="greenLabel"></el-table-column>
        <el-table-column
          align="center"
          prop="consume_time"
          label="消费时间"
          label-class-name="greenLabel"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="ticket_type"
          label="票种"
          :formatter="formatStr"
          label-class-name="greenLabel"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="ticket_from"
          label="购票渠道"
          :formatter="formatStr"
          label-class-name="greenLabel"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="pay_type"
          label="支付方式"
          :formatter="formatStr"
          label-class-name="greenLabel"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="person_num"
          label="可用人数"
          label-class-name="greenLabel"
        ></el-table-column>
        <el-table-column align="center" prop="total_price" label="票价(元)" label-class-name="greenLabel"></el-table-column>
      </el-table>

      <el-pagination
        :page-size="pagedata.size"
        layout="total, prev, pager, next, jumper"
        :total="pagedata.totalElements"
        :current-page.sync="pagedata.number"
        @current-change="query"
        class="mb"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: "chart",
  data() {
    return {
      queryCondition: {
        createDate: [],
        checkDate: [],
        ticketFrom: "",
        ticketType: "",
        ticketStatus: ""
      },
      ticket_status: [
        { code: 1, value: "未消费" },
        { code: 2, value: "已消费" },
        { code: 3, value: "已退款" },
      ],
      type_option: [],
      from_option: [],
      countSaleMoney: 0.0,
      countSalePerson: 0,
      countMeituanMoney: 0.0,
      countWeixinMoney: 0.0,
      countOtherMoney: 0.0,
      pagedata: {
        content: [],
        totalElements: 0,
        totalPages: 1,
        size: 10,
        number: 1,
      },
    };
  },
  mounted: function () {
    this.type_option = this.CommonUtil.getCodeList("ticket_type");
    this.from_option = this.CommonUtil.getCodeList("ticket_from");
    this.queryCondition.createDate = [this.DateUtil.getCurrentDate(), this.DateUtil.getCurrentDate()];
    this.init();
    this.query(1);
  },
  methods: {
    //状态改成汉字
    formatStr(row, column) {
      if (column.property == "ticket_type") {
        return this.CommonUtil.getCodeValue("ticket_type", row.ticket_type);
      }else if(column.property == 'pay_type'){
          return this.CommonUtil.getCodeValue('pay_type', row.pay_type);
      }else if (column.property == "status") {
        if(row.status == 1){
          return "未消费"
        }else if(row.status == 2){
          return "已消费"
        }else if(row.status == 3){
          return "已退款"
        }else{
          return "状态异常"
        }
      } else {
        return this.CommonUtil.getCodeValue("ticket_from", row.ticket_from);
      }
    },
    init() {
      let that = this;
      var url = "/chart/getTodayTotal";
            if (
        this.queryCondition.createDate != "" &&
        this.queryCondition.createDate != null &&
        this.queryCondition.createDate.length == 2
      ) {
        url += "?startDate=" + this.queryCondition.createDate[0];
        url += "&endDate=" + this.queryCondition.createDate[1];
      }
      this.$axios.get(url).then((res) => {
        var data = res.data;
        that.countSaleMoney = data.countSaleMoney;
        that.countSalePerson = data.countSalePerson;
        that.countMeituanMoney = data.countMeituanMoney;
        that.countWeixinMoney = data.countWeixinMoney;
        that.countOtherMoney = data.countOtherMoney;
      });
    },
    query(currentPage) {
      this.init();
      if (!isNaN(currentPage) && currentPage > 0) {
        this.pagedata.number = currentPage;
      }
      var url = "/ticket/financeLog";
      url += "?ticketFrom=" + this.queryCondition.ticketFrom;
      url += "&ticketType=" + this.queryCondition.ticketType;
      url += "&ticketStatus=" + this.queryCondition.ticketStatus;
      if (
        this.queryCondition.createDate != "" &&
        this.queryCondition.createDate != null &&
        this.queryCondition.createDate.length == 2
      ) {
        url += "&startCreateDate=" + this.queryCondition.createDate[0];
        url += "&endCreateDate=" + this.queryCondition.createDate[1];
      }
      if (
        this.queryCondition.checkDate != "" &&
        this.queryCondition.checkDate != null &&
        this.queryCondition.checkDate.length == 2
      ) {
        url += "&startCheckDate=" + this.queryCondition.checkDate[0];
        url += "&endCheckDate=" + this.queryCondition.checkDate[1];
      }

      url +=
        "&pageNumber=" +
        this.pagedata.number +
        "&pageSize=" +
        this.pagedata.size;
      this.$axios.get(url).then((response) => {
        this.pagedata = response.data;
      });
    },
    reset: function () {
      this.queryCondition.createDate = [];
      this.queryCondition.checkDate = [];
      this.queryCondition.ticketFrom = "";
      this.queryCondition.ticketType = "";
      this.queryCondition.ticketStatus = "";
      this.$refs.queryCondition.resetFields();
      this.query(1);
    },
    exportExcel: function(){
      var jqId = this.CommonUtil.getUserInfo().jqId;
      var url = this.GLOBAL.BASE_URL + "/file/exportFinance/";
      url += "?jqId=" + jqId;
      url += "&ticketFrom=" + this.queryCondition.ticketFrom;
      url += "&ticketType=" + this.queryCondition.ticketType;
      url += "&ticketStatus=" + this.queryCondition.ticketStatus;
      if (
        this.queryCondition.createDate != "" &&
        this.queryCondition.createDate != null &&
        this.queryCondition.createDate.length == 2
      ) {
        url += "&startCreateDate=" + this.queryCondition.createDate[0];
        url += "&endCreateDate=" + this.queryCondition.createDate[1];
      }
      if (
        this.queryCondition.checkDate != "" &&
        this.queryCondition.checkDate != null &&
        this.queryCondition.checkDate.length == 2
      ) {
        url += "&startCheckDate=" + this.queryCondition.checkDate[0];
        url += "&endCheckDate=" + this.queryCondition.checkDate[1];
      }
      window.location.href = url;
    }
  },
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/chart/money.vue